<style>
img[alt]:after {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: auto;
    height: auto;
    background-color: #fff;
    text-align: center;
    content: attr(alt);
}
</style>
<template>
    <img
        v-show="imgUrlAlt"
        @error="imgUrlAlt"
        :src="image"
        v-tooltip="title"
        :style="{ maxHeight: cssActivePx(height), maxWidth: cssActivePx(width)}"
        :width="width || undefined"
        :height="height || undefined"
        :alt="title || ''"
        :loading="lazy ? 'lazy' : undefined"
        :fetchpriority="lazy ? undefined : 'high'"
    />
</template>
<script>
export default {
    props: {
        src: [String],
        default: [String],
        height: [String, Number],
        width: [String, Number],
        title: [String],
        // Desactivar solo en imágenes visibles sin hacer scroll (p. ej. el
        // logo del login), ya que retrasan el Largest Contentful Paint.
        lazy: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            image: this.src
        };
    },
    methods: {
        imgUrlAlt: function() {
            this.image = this.default;
        },
        cssActivePx: function(val) {
            val = parseInt(val);
            return val > 0 ? val + "px" : false;
        }
    }
};
</script>
